import { WidgetSettings } from '@gsc/types'
import { WidgetRuntime } from '../runtime'

const AB_TEST_KEY = 'ab'

export function filterABTest(widgets: WidgetSettings[], runtime: WidgetRuntime) {
  let id
  let w: WidgetSettings

  const ab = runtime.storages.load(AB_TEST_KEY) || {} //todo: create separate storage for widgets campaigns
  const widgetOut: WidgetSettings[] = []
  // group widgets by groupId
  const groups: { [key: string]: null | WidgetSettings[] } = {}
  for (w of widgets) {
    if (!w.groupId) {
      widgetOut.push(w)
    } else {
      let group = groups[w.groupId]
      if (!group) {
        group = [w]
      } else {
        group.push(w)
      }
      groups[w.groupId] = group
    }
  }
  // Go through groups and decide which one to show
  for (const groupId of Object.keys(groups || {})) {
    let chosenIndex
    const widgetsToSelect = groups[groupId]
    if (widgetsToSelect) {
      if (ab[groupId]) {
        for (let i = 0; i < widgetsToSelect.length; i++) {
          w = widgetsToSelect[i]
          if (w.id === ab[groupId]) {
            chosenIndex = i
            break
          }
        }
      } else {
        chosenIndex = ab[groupId] || Math.floor(Math.random() * widgetsToSelect.length)
      }
      const selected = widgetsToSelect.splice(chosenIndex, 1)[0]
      ab[groupId] = selected.id
      widgetOut.push(selected)
    }
  }
  runtime.storages.save(AB_TEST_KEY, ab)
  return widgetOut
}
